module.exports = __webpack_public_path__ + "img/bg.274ef053.png";